/**
 * Returns the Strapi host without a trailing slash or `/api` suffix.
 *
 * This keeps API calls stable when `NEXT_PUBLIC_STRAPI_URL` is configured as
 * either `http://localhost:1337` or `http://localhost:1337/api`.
 */
const getStrapiBaseUrl = () => {
  const baseUrl = process.env.NEXT_PUBLIC_STRAPI_URL;

  if (!baseUrl) {
    return '';
  }

  return baseUrl.replace(/\/api\/?$/, '').replace(/\/$/, '');
};

/**
 * Builds a full Strapi URL from an API path and optional query params.
 *
 * Pass paths with the API prefix included, for example `/api/web/headers`.
 * The helper only normalizes the host and query string, so callers stay clear
 * about which Strapi route they are using.
 */
export const buildStrapiUrl = (
  path: string,
  params?: URLSearchParams,
): string => {
  const baseUrl = getStrapiBaseUrl();
  if (!baseUrl) {
    return '';
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const queryString = params?.toString();

  return `${baseUrl}${normalizedPath}${queryString ? `?${queryString}` : ''}`;
};
